export class UnAssignLeadsInput {
  leadIds: string[];
  comments?: string;
  comingFromCallModal?: boolean;
}
